import { render, staticRenderFns } from "./BoxPage.vue?vue&type=template&id=6f5b4e7a&"
import script from "./BoxPage.vue?vue&type=script&lang=ts&"
export * from "./BoxPage.vue?vue&type=script&lang=ts&"
import style0 from "./BoxPage.vue?vue&type=style&index=0&id=6f5b4e7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports